import React from "react";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import Home from "./Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CookieSetting } from "cookiesetting-component";
const App = () => {
  const appVersion = appversion.version;
  const isProduction = process.env.NODE_ENV === "production";

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={isProduction}
        isVerboseMode={false}
        metaFileDirectory={"*"}
      >
        <Routes>
            <Route
              path="refinance/:loName"
              element={<Home />}
            />
            <Route path="refinance/" element={<Home />} />
          </Routes>
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
  
      </CacheBuster>
      </>
     
    </BrowserRouter>
  );
};

export default App;

